import React from 'react';
import { Link } from 'react-router-dom';
import LinkStyledSimple from './LinkStyledSimple';
import LinkStyled from "./LinkStyled";
import ButtonPrimary from "./ButtonPrimary";
import ButtonSecondary from "./ButtonSecondary";
import axios from "axios";
import CONSTANTS from "../constants/constants";

/**
 * Story tile for the list of my stories. It contains CTA for View, Edit and Delete.
 */
export default function MyStoryTile(
  {
    ID,
    storyId,
    petName,
    created,
    status,
    images,
    updateData = () => void 0,
    className = '',
  }) {
  const media = images[0] || '';
  const viewStoryLink = `/apps/truestories/story/${ID}/draft`;
  const editStoryLink = `/apps/truestories/story/share/edit/${ID}`;
  const formatDate = date => new Date(date).toLocaleString('en-US');

  const deleteStory = () => {
    if (window.confirm('Do you really want to delete this story?')) {
      let customerId  = '';
      if (window.theme) {
        customerId = window.theme.customer.id;
      } else {
        customerId = window.ogShopifyConfig.customer.id;
      }
      axios.delete(`${CONSTANTS.baseUrl}api/truestories/delete/${customerId}/${storyId}/${ID}`)
        .then(() => {
          updateData();
        })
        .catch(console.error);
    }
  }

  return (
    <div className={`story-tile posr bd1-s-white bd1-s-gray-light:h pl10 pr10 pt26 pb26 ${className}`}>
      <Link
        className="story-tile__pet-media-container oh df aic jcc w100% h260 mb20 bgc-bgc-gray-lighter tdn"
        to={viewStoryLink}
      >
        {media.imageUrl ? (
          <img
            className="story-tile__pet-media-image w100%"
            alt={petName}
            src={media.imageUrl}
          />
        ) : (
          <div className="story-tile__placeholder w100% h100% df aic jcc bgc-gray-light c-red ff-gp fz32 fz25@md fzfw500">
            No Image Available
          </div>
        )}
      </Link>
      <div className="story-tile__pet-info">
        <div className="mb10">
          <LinkStyledSimple
            to={viewStoryLink}
          >
            {petName}
          </LinkStyledSimple>
        </div>

        <div className="story-tile__created mb8 fz12 fw500 ttu">
          Created: {formatDate(created)}
        </div>

        <div className="story-tile__status mb8 fz12 fw500 ttu posa t8 r8 bgc-red c-white p4 bdrs16 p8">
          {status}
        </div>

        <ButtonPrimary
          className="story-tile__view mt16 h48"
          compact
          to={viewStoryLink}
        >
          View Story
        </ButtonPrimary>

        <ButtonSecondary
          className="story-tile__edit mt8 c-red"
          to={editStoryLink}
        >
          Edit Story
        </ButtonSecondary>

        <div className="story-tile__delete tac">
          <LinkStyled
            className="mt16"
            onClick={deleteStory.bind(null, ID)}
          >
            Delete Story
          </LinkStyled>
        </div>

      </div>
    </div>
  );
}
